import React from 'react';
import PropTypes from 'prop-types';
import { processorTargets } from 'config';
import ScreenProcessorRuleUpdate from 'screens/ProcessorRule/Update';
import ScreenProcessorRuleCreate from 'screens/ProcessorRule/Create';
import ScreenProcessorRuleDetails from 'screens/ProcessorRule/Details';
import ScreenProcessorRuleList from 'screens/ProcessorRule/List';
import { REVIEW_PROCESSOR_RULE } from 'routes/paths';

const reviewProcessorRuleProps = {
  routePaths: REVIEW_PROCESSOR_RULE,
  target: processorTargets.REVIEWS,
};

const routeComponentPropTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

const ScreenReviewProcessorRuleUpdate = props => (
  <ScreenProcessorRuleUpdate {...props} {...reviewProcessorRuleProps} />
);

const ScreenReviewProcessorRuleCreate = props => (
  <ScreenProcessorRuleCreate {...props} {...reviewProcessorRuleProps} />
);

const ScreenReviewProcessorRuleDetails = props => (
  <ScreenProcessorRuleDetails {...props} {...reviewProcessorRuleProps} />
);

const ScreenReviewProcessorRuleList = props => (
  <ScreenProcessorRuleList
    {...props}
    {...reviewProcessorRuleProps}
    titleKey="review_processor_rule.list.title"
  />
);

ScreenReviewProcessorRuleUpdate.propTypes = routeComponentPropTypes;
ScreenReviewProcessorRuleCreate.propTypes = routeComponentPropTypes;
ScreenReviewProcessorRuleDetails.propTypes = routeComponentPropTypes;
ScreenReviewProcessorRuleList.propTypes = routeComponentPropTypes;

const reviewProcessorRulesRoutes = [
  {
    path: REVIEW_PROCESSOR_RULE.UPDATE,
    name: 'ReviewProcessorRuleUpdate',
    component: ScreenReviewProcessorRuleUpdate,
    allowPermissions: ['change_processorrule'],
  },
  {
    path: REVIEW_PROCESSOR_RULE.CREATE,
    name: 'ReviewProcessorRuleCreate',
    component: ScreenReviewProcessorRuleCreate,
    allowPermissions: ['add_processorrule'],
  },
  {
    path: REVIEW_PROCESSOR_RULE.DETAILS,
    name: 'ReviewProcessorRuleDetails',
    component: ScreenReviewProcessorRuleDetails,
    allowPermissions: ['view_processorrule'],
  },
  {
    path: REVIEW_PROCESSOR_RULE.LIST,
    name: 'ReviewProcessorRuleList',
    component: ScreenReviewProcessorRuleList,
    loginRequired: true,
    allowPermissions: ['list_processorrule'],
  },
];

export default reviewProcessorRulesRoutes;
